import { Link } from "react-router-dom";

function CtaBand() {
  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-50">
      <div className="relative rounded-lg overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20golden%20hour%20city%20skyline%20abstract%20silhouette%20with%20soft%20amber%20haze%20and%20gentle%20light%20leaks%2C%20calm%20minimal%20atmosphere%2C%20no%20people%2C%20cinematic%20editorial%20photography%20high%20detail&width=1600&height=600&seq=guaspeed-cta-band&orientation=landscape"
          alt="瓜圈速报线索征集氛围图"
          title="瓜圈速报 - 有线索就来投"
          className="w-full h-full object-cover object-top absolute inset-0"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/75 to-foreground-950/55" />

        <div className="relative px-6 md:px-12 py-14 md:py-20 max-w-2xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500 text-secondary-950 text-xs font-bold">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-send-plane-fill" />
            </span>
            线索征集
          </span>
          <h2 className="mt-5 font-heading text-2xl md:text-4xl font-black text-background-50 dark:text-foreground-950 leading-tight">
            你手上的那张图，
            <br />
            可能就是下一条速报
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-200/90 dark:text-foreground-800/90 leading-relaxed max-w-xl">
            拍到、听到、看到什么，都可以丢给我们。附上时间、地点和公开来源，我们会自行核实，再决定要不要整理成快讯。
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <a
              href="mailto:hi@guaspeed.example.com"
              rel="nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line" />
              </span>
              发线索到编辑部
            </a>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50/15 dark:bg-foreground-950/15 border border-background-50/25 dark:border-foreground-950/25 text-background-50 dark:text-foreground-950 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-background-50/25 dark:hover:bg-foreground-950/25 transition-colors"
            >
              了解内容原则
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CtaBand;